import React, {Component} from "react";
import TreeSelectModal from "../../../../../components/treeSelectModal/TreeSelectModal";
import BaseComponent from "../../../../../base/BaseComponent";
import {generateTreeData, treeForEach, filterForEach} from "../../../../../utils";

export default class DeptSelectModal extends BaseComponent {
    static defaultProps = {
        isEnable:true,
        disableKeys:[],
        defaultBtnType:'inputBtn',//textBtn
    };
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            updateFlag: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value) {
            this.setTreeData();
        }
    }

    componentDidMount() {
        // 项目设置进入页面不调接口
        if(this.props.isSystemSetup){
            return
        }
        this.setTreeData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
    }

    render() {
        const {
            multiple,
            value,
            title = "选择部门",
            checkStrictly,
            onItemDelete,
            placeholder,
            disableAllDept,
            onDisableAllDeptCall,
            disableKeys,
        } = this.props;

        const {
            treeData,
            autoExpandParent,

            expandedKeys,
            checkedKeys
        } = this.state;

        let valueList = [];

        if (multiple) {
            treeForEach(treeData, node => {
                if (value.includes(node.id)) {
                    valueList.push({
                        label: node.title,
                        value: node.id
                    });
                }
            });
        } else {
            treeForEach(treeData, node => {
                if (node.id === value) {
                    valueList = [{
                        label: node.title,
                        value: node.id
                    }];
                }
            });
        }

        return (
            /*    treeData.length ?*/
            <TreeSelectModal
                ref={treeSelectModal => this.treeSelectModal = treeSelectModal}
                title={title}
                defaultBtnType={this.props.defaultBtnType}
                valueList={valueList}
                treeData={treeData}
                autoExpandParent={autoExpandParent}
                expandedKeys={expandedKeys}
                onExpand={this.onExpand}
                showIcon={true}
                checkStrictly={checkStrictly}
                checkable={true}
                onCheck={this.onCheck}
                isEnable={this.props.isEnable}
                checkedKeys={checkedKeys}
                handleOk={this.handleOk}
                showModalHandle={this.showModalHandle}
                onItemDelete={onItemDelete}
                placeholder={placeholder}
                isSearch={'isSearch'}
                showSearch={true}
                disableAllDept={disableAllDept}
                onDisableAllDeptCall={onDisableAllDeptCall}
                disableKeys={disableKeys}
            />
            /*: null*/

        )
    }


    onCheck = c => {
        const {multiple} = this.props;
        if (multiple) {
            this.setState({
                checkedKeys: c
            });
        } else {
            while (c.checked.length > 1) {
                c.checked.shift();
            }
            this.setState({
                checkedKeys: c
            });
        }
    };
    handleOk = () => {
        const {multiple} = this.props;
        const {checkedKeys: {checked}} = this.state;
        let data;
        if (multiple) {
            data = checked;
        } else {
            data = checked[0];
        }
        this.props.handleOk(data, this.state.treeData);
    };

    showModalHandle = () => {
        const {value, checkStrictly, multiple} = this.props;
        let checkedKeys = [];
        // checkStrictly 不同 数据结构不同
        if (checkStrictly) {
            // multiple 多选接受数组
            if (multiple) {
                checkedKeys = {checked: value};
            } else {
                checkedKeys = {checked: [value]};
            }
        } else {
            checkedKeys = [value];
        }

        this.setState({
            checkedKeys
        });
        this.setTreeData();
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };


    // 获取树数据
    setTreeData = () => {
        const {currentDept, value} = this.props;
        const treeDataIndex = {
            id: "id",
            title: "name",
            children: "child",
            key: "id"
        };
        this.deptGetTreeRequest(res => {
            let treeData = generateTreeData([res], treeDataIndex);
            const expandedKeys = [];
            treeForEach(treeData, node => {
                // 不能选择当前部门及一下的部门
                if (node.id === currentDept) {
                    node.children = null;
                }
                if (node.children && node.children.length) {
                    expandedKeys.push(node.id);
                }
            });
            treeData = filterForEach(treeData, node => {
                return node.id !== currentDept;
            });
            this.onExpand(expandedKeys);
            this.setState({
                treeData
            });
        });
    };

    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };
}

